<script lang="ts">
    import { fade } from 'svelte/transition';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import type { NotificationSystemContext } from './NotificationSystemContext';
    import { Navigation } from '../../utilities/Navigation';
    import { NotificationSystem } from './NotificationSystem';
    import { openModal } from 'svelte-modals';
    import ModalCustom from '../../shared/Modals/ModalCustom.svelte';
    import JobList from './JobList.svelte';
    import { Umami } from '../../utilities/Umami';

    export let disabled: boolean = false;

    let context: NotificationSystemContext;

    const reloadData = (ctx: NotificationSystemContext) => {
        context = ctx;
    };

    onMount(() => {
        $NotificationSystem.start(reloadData);

        return () => {
            $NotificationSystem.stop();
        };
    });

    $: {
        if (disabled) {
            $NotificationSystem.stop();
        } else {
            $NotificationSystem.start(reloadData);
        }
    }
</script>

<div class="monitoring-system-container">
    {#if context && $NotificationSystem.areThereAnyAdhocs()}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="info"
            title="Zlecenia ad-hoc do przydzielenia i zatwierdzenia"
            on:click={async () => {
                //Navigation.navigate('/planning');
                context = await $NotificationSystem.getJobsData();
                openModal(ModalCustom, {
                    component: JobList,
                    componentProps: { jobs: context?.jobAdHocNotRejected, title: $_('new')+' ad-hoc' },
                });
            }}
            transition:fade={{ duration: 500 }}
        >
            <div class="description">
                <span style="text-transform: capitalize">{$_('new')}</span>
                <span
                    style="color: var(--planning-page-accent-color); padding-left: 3px; font-weight: 600;"
                    >ad-hoc</span
                >
            </div>
            <div class="value">{context?.jobAdHocNotRejectedQuery}</div>
        </div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="info"
            title="Zlecenia ad-hoc do przydzielenia i zatwierdzenia"
            on:click={async () => {
                //Navigation.navigate('/planning');
                context = await $NotificationSystem.getJobsData();
                openModal(ModalCustom, {
                    component: JobList,
                    componentProps: { jobs: context?.jobAdHocRejected, title: $_('rejected')+' ad-hoc' },
                });
            }}
            transition:fade={{ duration: 500 }}
        >
            <div class="description">
                <span style="text-transform: capitalize">{$_('rejected')}</span>
                <span
                    style="color: var(--planning-page-accent-color); padding-left: 3px; font-weight: 600;"
                    >ad-hoc</span
                >
            </div>
            <div class="value">{context?.jobAdHocRejectedQuery}</div>
        </div>
    {/if}
    {#if context && $NotificationSystem.areThereAnyRejected()}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="info"
            title="Odrzucone zlecenia"
            on:click={async () => {
                //Navigation.navigate('/planning');
                context = await $NotificationSystem.getJobsData();
                Umami.event('driver_job_rejection_viewed', { count: context?.jobRejectedQuery });
                openModal(ModalCustom, {
                    component: JobList,
                    componentProps: { jobs: context?.jobRejected, title: $_('Jobs')+' '+$_('rejected') },
                });
            }}
            transition:fade={{ duration: 500 }}
        >
            <div class="description">
                <span style="text-transform: capitalize">{$_('Jobs')}</span>
                <span
                    style="color: var(--planning-page-accent-color); padding-left: 3px; font-weight: 600;"
                    >{$_('rejected')}</span
                >
            </div>
            <div class="value">{context?.jobRejectedQuery}</div>
        </div>
    {/if}
</div>

<style>
    .monitoring-system-container {
        display: flex;
        flex-direction: row;
        column-gap: 9px;
    }
    .info {
        /*color: #3e352e;*/
        background-color: #f0f0f0;
        cursor: pointer;
        padding: 4px 6px;
        min-width: 120px;
        display: flex;
        flex-direction: column;
        justify-content: right;
        align-items: flex-end;
        row-gap: 3px;
        border-radius: 6px;
        /*padding: 10px;*/
        /*margin: 10px;*/
        /*border: 1px solid black;*/
    }
    .description {
        font-size: 12px;
    }
    .value {
        font-size: 14px;
        font-weight: 600;
        color: var(--planning-page-accent-color);
    }
</style>
